import { Toast } from 'mint-ui'
import {global} from './api.config'
import axios from 'axios'
// import env from '../../../build/env'
const platform = require('platform')
const zglClienttype = 'ZgLiveStudentH5'
const zglSystemtype = platform.os.family || 'Unknown'
const zglSystemversion = platform.os.version
const zglBrowsertype = platform.name
const zglBrowserversion = platform.version
console.log('platform ' + platform)
// import Cookies from 'js-cookie';
const URL_PROTOCOL = window.location.protocol
// const SERVER_BASE_URL = `${URL_PROTOCOL}//dev-api.live.offcncloud.com/api/v1`
// const SERVER_BASE_URL = env === 'development'
//   ? 'https://live.offcncloud.com/api'
//   : 'https://live.offcncloud.com/api'
let SERVER_BASE_URL = ''
if (process.env.NODE_ENV === 'production') {
  SERVER_BASE_URL = global.online_url
} else {
  SERVER_BASE_URL = global.test_url
}
export {
  URL_PROTOCOL,
  SERVER_BASE_URL
}
// let token = null
export default function fetch (options) {
  // token = sessionStorage.getItem('offcn_live_token')
  return new Promise((resolve, reject) => {
    const instance = axios.create({
      baseURL: SERVER_BASE_URL,
      headers: {
        // 'Authorization': token,
        // 'x-debug': 'cqh12345', // 本地环境调试绕开登录状态使用，上线前记得注销
        'zgl-clienttype': zglClienttype,
        'zgl-systemtype': zglSystemtype,
        'zgl-systemversion': zglSystemversion,
        'zgl-browsertype': zglBrowsertype,
        'zgl-browserversion': zglBrowserversion

      },
      transformResponse: [function (data) {
      }]
    })
    instance.interceptors.request.use(
      config => {
        // Indicator.open({
        //   // text: '加载中...',
        //   spinnerType: 'snake',
        //   className: 'offcn-Indicator'
        // })
        // Indicator.open({
        //   // text: '加载中...',
        //   spinnerType: 'snake',
        //   className: 'offcn-Indicator'
        // })
        config.headers['Content-Type'] = 'application/json;charset=utf-8'
        return config
      },
      err => {
        return Promise.reject(err)
      })

    instance.interceptors.response.use(
      response => {
        // Indicator.close()
        // setTimeout(function () {
        //   Indicator.close()
        // }, 250)
        let res = response.request.response
        res = JSON.parse(res)
        if (res.code !== 0) {
          if (!options.customError) {
            // Toast(res.msg)
            // Toast({
            //   message: res.msg,
            //   className: 'offcn-toast'
            // })
          }
          // return res
        }
        // return Promise.resolve(response);
        return res
      },
      error => {
        // Indicator.close()
        Toast({
          message: '网络不给力，请稍后重试',
          className: 'offcn-toast'
        })
        // Toast(error.message || '网络出错啦，稍后再试~')
        return Promise.reject(error) // 返回接口返回的错误信息
      })

    // 请求处理
    instance(options)
      .then((res) => {
        resolve(res)
        return false
      })
      .catch((error) => {
        reject(error)
      })
  })
}



// WEBPACK FOOTER //
// ./src/common/api/api.js